import React,{ useState , useEffect} from 'react';
import headerImg from '../images/maybank.png'; // change the correct image
import config from '../appconfig/config.json';
import CusFormTitle from '../components/CusFormTitle';
import previewData from '../data/previewdata.json';
import comdetailsdata from '../data/comdetailsdata.json';
import SubHeader from '../components/SubHeader';
import { Form, FormElement, Field, FieldWrapper } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import { CusFormLabel, TermsFormCheckboxNoErrMsgDisplay } from '../validation/Form-Components';
import BizRegisterAddress from '../components/BizRegisterAddress';
import BizMailingAddress from '../components/BizMailingAddress';
import FinancialHighlights from '../components/FinancialHighlights';
import PersonDtlsPreview from '../components/PersonDtlsPreview';
import {  previewValidator } from '../validation/Validators';
import { useHistory } from "react-router-dom";
import helper from '../factory/Helper.js';
import OTPbar from '../components/OTPbar';
import personData from '../data/persondetailsdata.json';
import Loading from '../components/Loading';
import service from '../services/PreviewApiService';
import BizDtlsPreview from '../components/BizDtlsPreview';
import PersonDtlsPendingPreview from '../components/PersonDtlsPendingPreview';
import storage from '../factory/StorageFactory';
import productFinancing from "../data/financingproduct.json";
import CusToast from '../components/CusToast';
import apiService from '../services/ApiService';
import MFinancialPreview from '../components/MFinancialPreview';
import mData from '../hybriddata/mainform.json';
import PropertyAddress from '../hybridcomponents/PropertyAddress.jsx';
import pData from '../hybriddata/propertydata.json';
import LeaseholdPreview from '../hybridcomponents/LeaseholdPreview.jsx';
import BankBalanceHistory from '../hybridcomponents/BankBalanceHistory.jsx';
import CommitmentHistory from '../hybridcomponents/CommitmentHistory.jsx';
 
 
const Preview = (props) => {
  const  authPer1 = '1', authPer2 = '2',authPer3 = '3', authPer4='4', authPer5='5';
  const preKOSubmitted = 'Submitted', preKORejected = 'Rejected';

  const history = useHistory();
  const initialResState = {};
  let timer;
  const [response, setResponse] = useState(initialResState);
  const [isLoading, setIsLoading] = useState(true);  //to show api call
  const [isSubmitting, setIsSubmitting] = useState(false);
 
  const [currentTime,setCurrentTime] = useState();

  const [showOTPBar,setShowOTPBar] = useState(false);

  const [isError,setIsError] = useState(false);
  const [errMsg, setErrMsg] = useState('');
 
  const [initFormData, setInitFormData] = useState({
    PreviewClare:false
  });
  const [personDetails1, setPersonDetails1] = useState();
  const [completedApplicants,setCompletedApplicants] = useState([]);
  const [pendingApplicants,setPendingApplicants] = useState([]);
  const [financialHighlights,setFinancialHighlights] = useState({})
  const [loginAPCPFHistory, setLoginAPCPFHistory] = useState(null);
  const [loginAPYrAssestment, setLoginAPYrAssestment] = useState(null);

  //Property Detials - BankBanlance
  const [isPureAIP, setIsPureAIP] = useState(false);
  const [showMaybankAcctDtls, setShowMaybankAcctDtls] = useState(false);
  const [bankBalanceList, setBankBalanceList] = useState([])
  const [monthlyDebtCommitList, setMonthlyDebtCommitList] = useState([]);


  useEffect(() => {
   
    // if(helper.isTokenExpired()) {
    //     history.push(config.route.SessionExpired);
    //     return;
    // }

    // if(helper.isInvalidState()) {
    //   window.location.href =  config.link.BacktoHome;
    //   return;
    // }

    window.scrollTo(0,0);

    getData();
    
    return () => {
 
      clearTimeout(timer);
    }
 }, []);

 const setIsPureAIPFlag = (data) => {
 
  const resData =data.Request_Form;
  if(resData.FinancingProduct === config.bizFinancing.AIP) {
    if(resData.IsExistingOTPAvailable && resData.IsExistingOTPAvailable === 'N'
      && data.companydetails.CompDtls.SoleorNonSole === config.bizConst.NonSole  
      && (helper.isDateMorethanOneYrAgo(data.companydetails.CompDtls.Registration_Date) === true) 
      && (isValidSSICForAIP(data) === true)
    ) {
      setIsPureAIP(true);
    }
    else {
      setIsPureAIP(false);
    }
  }
  else {
    setIsPureAIP(false);
  }
 }

 const getIsPureAIPFlag = (data) => {
  const resData =data.Request_Form;
  if(resData.FinancingProduct === config.bizFinancing.AIP) {
    if(resData.IsExistingOTPAvailable && resData.IsExistingOTPAvailable === 'N'
      && (helper.isDateMorethanOneYrAgo(data.companydetails.CompDtls.Registration_Date) === true) 
      && (isValidSSICForAIP(data) === true)
    ) {
      return true;
    }
    else {
      return false;
    }
  }

  return false;
 }

 const isValidSSICForAIP = (data) => {
  let isValid = false;
  const primarySSIC = data.companydetails.CompDtls.Primary_Activity_Code;
  const secondarySSIC = data.companydetails.CompDtls.Secondary_Activity_Code;
  if(primarySSIC !== null) {
      if(primarySSIC === '64202') { 
          isValid = false;
      }
      else { 
          isValid = true;
      }
  }
  else if(secondarySSIC !== null) {
      if(primarySSIC === '64202') { 
          isValid = false;
      }
      else { 
          isValid = true;
      }
  }
  return isValid;
}

 
const differenceInMonths = (date1, date2) => {
  const monthDiff = date1.getMonth() - date2.getMonth();
  const yearDiff = date1.getYear() - date2.getYear();

  return monthDiff + yearDiff * 12;
}

  const handleSubmit = (eve) => {
  
    if(helper.isTokenExpired()) {
      history.push(config.route.SessionExpired);
      return;
    }

    if(helper.isInvalidState()) {
      window.location.href =  config.link.BacktoHome;
      return;
    }

    if(eve.isValid){

        if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') { //first AP
          if(validateForm() === 'true' && validatePersonDetails() === true) {
        
            if(config.IsWAAEnabled) {
              preQualificationKnockout();
            }
            else { //disable waa 
              if(config.EnableOTPbar){
                setShowOTPBar(true);
              }
              else {
                //route to comple status page
                submitWithFields();
              }
            }

            return;
          }
        }
        else {// sub AP
          if(config.EnableOTPbar){
            setShowOTPBar(true);
          }
          else {
            //route to comple status page
            submitWithFields();
          }
        }
       
    }
  }
  const handleBack = (e) => {
    e.preventDefault();
    history.push(config.route.DeclarationsDetails, { from: config.route.Preview });
  }

  const handleOnEdit = (id) => {
 
    if(id === config.route.FinanceDetails) {
      let refNo = storage.getRefNo();
      history.push('editdetails?refNo='+refNo, { from: config.route.Preview });
    }
    if(id === config.route.CompanyDetails) {
      let sid = storage.getStateId();
      history.push(config.route.CompanyDetails+'?state='+sid, { from: config.route.Preview });
    }
    if(id === config.route.AccountDetails) {
      history.push(config.route.AccountDetails, { from: config.route.Preview });
    }
    if(id === config.route.NSPersonDetails) {
      history.push(config.route.NSPersonDetails, { from: config.route.Preview });
    }
    if(id === config.route.PropertyDetails) {
      if(storage.getIsPureAIP() === 'true' || isPureAIP) {
        history.push(config.route.PropertyDetailsAIP, { from: config.route.Preview });
      }
      else {
        history.push(config.route.PropertyDetails, { from: config.route.Preview });
      }
    }
  }
  const getData = () => {
    getOTPCurrentTime();
    service.get().then( res => {
      if(res.data.isSucess) {
        const resData = res.data.model.fields.request;
        setIsPureAIPFlag(resData);
        setResponse(resData);
        bindFormData(resData);
      }
      else {
        showErrMsg(config.error.GetApiFailed);
      }
      setIsLoading(false);
    })
    .catch(err=>{
      console.log('err=>',err);
      setIsLoading(false);
      showErrMsg(config.error.GetApiFailed);
    })
  }

  const preQualificationKnockout = () => {
    
    apiService.preKnockout(config.AppStage.APPSUBMIT).then(res => {
        let resData = res.data;
        const preKOErrorCode = resData.model.error.code;
        setIsLoading(false);
        if(resData.model.status.toUpperCase() === 'SUCCESS' || resData.model.status.toUpperCase() == 'GREEN') {
          //preknockout success, proceed for OTP
          if(config.EnableOTPbar){
            setShowOTPBar(true);
          }
          else {
            //route to comple status page
            submitWithFields();
          }
        }
        else {
          //Preknockout failed then call submit api to reject
          let params = {
            RefNo:storage.getRefNo(),
            OrderNumber:getAPOrderNo(),
            IDNumber:response.ApplicantsDtlsMyInfo.IDNumber.trim(),
            Status: preKORejected,  // addtional for PreKnockout Status
            IsNonLendingCompleted:getIsNonLendingCompleted()
          }
        
          service.submit(params).then(res => {   
            
            goPreKnockoutFailed(preKOErrorCode);

            }).catch(err => {
              console.log('err: ',err);
              showErrMsg(config.error.SaveApiFailed);
            })
        }
    }).catch(err=> {
        console.log('@preQualificationKnockout ',err)
        setIsLoading(false);
        goPreKnockoutFailed('M12');
    })
}

const goPreKnockoutFailed = (errorType) => {
    let errCode;
    if(errorType === null) {
      errCode= 'M12';
    }
    else {
      errCode = errorType;
    }
   
    history.push(config.route.PreKnockoutFailed,{errType:errCode});
}

  const bindFormData = (resData) => {
    createFinancialHightlights(resData);
    bindPersonDetails(resData);
    if(resData.Request_Form.FinancingProduct !== config.bizFinancing.BTL) { //not BTL, then required

      if(getIsPureAIPFlag(resData)) { //Pure AIP
        checkShowMaybankAcctDtls(resData);
        bindBankBalanceList(resData);
        bindMontlyDebtCommitments(resData);
      }
    }
  }

  const createFinancialHightlights = (data) => {
    let temp = [], min=[], max = [];
    if(!Array.isArray(data.companydetails.financialHighlights)) {
        temp.push(data.companydetails.financialHighlights);
    }
    else {
        temp = data.companydetails.financialHighlights;
    }

    for (let i in temp) {
        max.push(temp[i]);
        if(i < 2) min.push(temp[i]);
    }
    
    setFinancialHighlights({
        minData:min,
        maxData:max
    });
}

const createCPFHistory = (data) => {
  let temp = [], min=[], max = [];
  if(data.cpfContributionHistory && data.cpfContributionHistory !== null) {
    if(!Array.isArray(data.cpfContributionHistory)) {
      temp.push(data.cpfContributionHistory);
  }
  else {
      temp = data.cpfContributionHistory;
  }

  for (let i in temp) {
      max.push(temp[i]);
      if(i < 2) min.push(temp[i]);
  }
  
  setLoginAPCPFHistory({
      minData:min,
      maxData:max
  });
  }
  else {
    setLoginAPCPFHistory({
      minData:min,
      maxData:max
  });
  }
}

const createAPYrofAssestment = (data) => {
      
  if(data.yearOfAssessment && data.yearOfAssessment !== null) {
      let firstYrData = null;
      let secYrData = null;

      if(!Array.isArray(data.yearOfAssessment.income)) { // object
        firstYrData = data.yearOfAssessment.income;
        secYrData = null;
      }
      else { // array
         for(let i in data.yearOfAssessment.income) {
           if(data.yearOfAssessment.income[i].RowNumber === "1") {
              firstYrData = data.yearOfAssessment.income[i];
           }
           else if(data.yearOfAssessment.income[i].RowNumber === "2") {
              secYrData = data.yearOfAssessment.income[i];
           }
         }
      }
      
      setLoginAPYrAssestment({
          firstYear: {
              employment: firstYrData === null? null: firstYrData.employment,
              taxCategory: firstYrData === null? null:firstYrData.taxCategory,
              year:firstYrData === null? null:firstYrData.year,
              taxClearance: firstYrData === null? null:firstYrData.taxClearance,
              assessableIncome: firstYrData === null? null:firstYrData.assessableIncome,
              trade: firstYrData === null? null:firstYrData.trade,
              rent: firstYrData === null? null:firstYrData.rent,
              interest: firstYrData === null? null:firstYrData.interest
            },
            secondYear: {
              employment: secYrData === null? null: secYrData.employment,
              taxCategory: secYrData === null? null: secYrData.taxCategory,
              year:secYrData === null? null: secYrData.year,
              taxClearance: secYrData === null? null: secYrData.taxClearance,
              assessableIncome: secYrData === null? null: secYrData.assessableIncome,
              trade: secYrData === null? null: secYrData.trade,
              rent: secYrData === null? null: secYrData.rent,
              interest: secYrData === null? null: secYrData.interest
            }
      });
  }
  else {
      setLoginAPYrAssestment({
          firstYear: {
              employment: null,
              taxCategory: null,
              year:null,
              taxClearance: null,
              assessableIncome: null,
              trade: null,
              rent: null,
              interest: null
            },
            secondYear: {
              employment: null,
              taxCategory: null,
              year:null,
              taxClearance: null,
              assessableIncome: null,
              trade: null,
              rent: null,
              interest: null
            }
      });
  }
}

const bindPersonDetails = (resData) => {
    
    createCPFHistory(resData.ApplicantsDtlsMyInfo);
    createAPYrofAssestment(resData.ApplicantsDtlsMyInfo);

    let submittedAPs = [], pendingAPs = [] ;
   
    const ApplicantDtls = resData.ApplicantDtls;
    if(!Array.isArray(ApplicantDtls)) {
      let completedAP = getCompletedAPs(ApplicantDtls,resData);
      let pendingAP = getPendingAPs(ApplicantDtls,resData);
      if(Object.entries(completedAP).length !== 0) {
        submittedAPs.push(completedAP);
      } 
      if(Object.entries(pendingAP).length !== 0) {
        pendingAPs.push(pendingAP);
      }
    }
    else {
      for(let i in ApplicantDtls) {
        let completedAP = getCompletedAPs(ApplicantDtls[i],resData);
        let pendingAP = getPendingAPs(ApplicantDtls[i],resData);
        if(Object.entries(completedAP).length !== 0) {
          submittedAPs.push(completedAP);
        } 
        if(Object.entries(pendingAP).length !== 0) {
          pendingAPs.push(pendingAP);
        } 
    }
    }
   

    setCompletedApplicants(submittedAPs);
    setPendingApplicants(pendingAPs);

    setPersonDetails1(authPer1); 
    setIsLoading(false);
}

const getCompletedAPs = (authPerson,resData) =>{
 
  let submittedAPs= {};
  const myInfoData = resData.ApplicantsDtlsMyInfo;
  const SubmittedApplicants = resData.SubmittedApplicants;
  if(checkIsLoginUser(authPerson,myInfoData)) {
 
    submittedAPs= {
      myInfo:myInfoData,
      allowEdit: checkAllowEdit(authPerson,myInfoData),
      showCPFAndNOA: showAPCPFAndNOA(authPerson,myInfoData)
    }
  }
  else {
    if(authPerson.OrderNumber === authPer1 && SubmittedApplicants.Applicant1 === 'true') {
  
      submittedAPs= {
        myInfo:authPerson,
        allowEdit: checkAllowEdit(authPerson,myInfoData),
        showCPFAndNOA: showAPCPFAndNOA(authPerson,myInfoData)
      }
    }

    if(authPerson.OrderNumber === authPer2 && SubmittedApplicants.Applicant2 === 'true') {
      submittedAPs= {
        myInfo:authPerson,
        allowEdit: checkAllowEdit(authPerson,myInfoData),
        showCPFAndNOA: showAPCPFAndNOA(authPerson,myInfoData)
      }
    }

    if(authPerson.OrderNumber === authPer3 && SubmittedApplicants.Applicant3 === 'true') {
      submittedAPs= {
        myInfo:authPerson,
        allowEdit: checkAllowEdit(authPerson,myInfoData),
        showCPFAndNOA: showAPCPFAndNOA(authPerson,myInfoData)
      }
    }

    if(authPerson.OrderNumber === authPer4 && SubmittedApplicants.Applicant4 === 'true') {
      submittedAPs= {
        myInfo:authPerson,
        allowEdit: checkAllowEdit(authPerson,myInfoData),
        showCPFAndNOA: showAPCPFAndNOA(authPerson,myInfoData)
      }
    }

    if(authPerson.OrderNumber === authPer5 && SubmittedApplicants.Applicant5 === 'true') {
      submittedAPs= {
        myInfo:authPerson,
        allowEdit: checkAllowEdit(authPerson,myInfoData),
        showCPFAndNOA: showAPCPFAndNOA(authPerson,myInfoData)
      }
    }
  }
 
  return submittedAPs;
}

const getPendingAPs = (authPerson,resData) => { 
  let pendingAPs= {};
  const myInfoData = resData.ApplicantsDtlsMyInfo;
  const SubmittedApplicants = resData.SubmittedApplicants;
  if(checkIsLoginUser(authPerson,myInfoData) === false) {
    if(authPerson.OrderNumber === authPer1 && SubmittedApplicants.Applicant1 === 'false') {
      pendingAPs = {
        myInfo:authPerson,
        allowEdit: checkAllowEdit(authPerson,myInfoData),
        showCPFAndNOA: showAPCPFAndNOA(authPerson,myInfoData)
      }
    }

    if(authPerson.OrderNumber === authPer2 && SubmittedApplicants.Applicant2 === 'false') {
      pendingAPs = {
        myInfo:authPerson,
        allowEdit: checkAllowEdit(authPerson,myInfoData),
        showCPFAndNOA: showAPCPFAndNOA(authPerson,myInfoData)
      }
    }

    if(authPerson.OrderNumber === authPer3 && SubmittedApplicants.Applicant3 === 'false') {
      pendingAPs = {
        myInfo:authPerson,
        allowEdit: checkAllowEdit(authPerson,myInfoData),
        showCPFAndNOA: showAPCPFAndNOA(authPerson,myInfoData)
      }
    }

    if(authPerson.OrderNumber === authPer4 && SubmittedApplicants.Applicant4 === 'false') {
      pendingAPs = {
        myInfo:authPerson,
        allowEdit: checkAllowEdit(authPerson,myInfoData),
        showCPFAndNOA: showAPCPFAndNOA(authPerson,myInfoData)
      }
    }

    if(authPerson.OrderNumber === authPer5 && SubmittedApplicants.Applicant5 === 'false') {
      pendingAPs = {
        myInfo:authPerson,
        allowEdit: checkAllowEdit(authPerson,myInfoData),
        showCPFAndNOA: showAPCPFAndNOA(authPerson,myInfoData)
      }
    }
  }

  return pendingAPs;
}

 
const checkIsLoginUser = (authPerson,loginUser) => {
 
  if(authPerson.IDNumber.trim() === loginUser.IDNumber.trim()) {
    return true;
  }
  return false;
}
 
const checkIsFirstUser = (loginUser) => {
  if(loginUser.isFirstUser === 'true') {
    return true;
  }
  return false;
}

const checkAllowEdit = (authPerson,loginPerson) => {
 
  if(loginPerson.isFirstUser === 'true') {
      return true;
  }
  else if(authPerson.IDNumber.trim() === loginPerson.IDNumber.trim()) {
      return true;
  }
  else {
      return false;
  }
}


const showAPCPFAndNOA = (authPerson,loginPerson) => {
  if(authPerson.IDNumber.trim() === loginPerson.IDNumber.trim()) {  //login user
      return true;
  }
  else {
      return false;
  }
}

const getAPOrderNo = () => {
  
  if(!Array.isArray(response.ApplicantDtls)) { //if one AP
    return response.ApplicantDtls.OrderNumber;
  }
  else {
    for(let i in response.ApplicantDtls) { //if more than one AP, get login user AP's OrderNo
      if(response.ApplicantsDtlsMyInfo.IDNumber.trim() === response.ApplicantDtls[i].IDNumber.trim()) {
        return response.ApplicantDtls[i].OrderNumber;
      }
    }
  }
}

const getAPMobileNo = () => {
  
  if(!Array.isArray(response.ApplicantDtls)) { //if one AP
    return response.ApplicantDtls.MobileNumber;
  }
  else {
    for(let i in response.ApplicantDtls) { //if more than one AP, get login user AP's OrderNo
      if(response.ApplicantsDtlsMyInfo.IDNumber.trim() === response.ApplicantDtls[i].IDNumber.trim()) {
        return response.ApplicantDtls[i].MobileNumber;
      }
    }
  }
}

//Bank Balance Details
const checkShowMaybankAcctDtls = (resData) => {
  if(resData.PropertyDetails.TypeOfFinance === pData.typeOfFinanceRdo.firstValue) { //new purchase
    if(resData.PropertyDetails.Purpose === pData.purposePropertyRdo.firstValue) { //Biz ops - show
      if(resData.PropertyDetails.PropertyInMind === 'Y') {
        if(resData.PropertyDetails.PropertyType === pData.propTypeShopCode) { //shophouse - hide
          setShowMaybankAcctDtls(false);
        }
        else{
          setShowMaybankAcctDtls(true);
        }
      }
      else {
        setShowMaybankAcctDtls(true);
      }
    }
    else { //IS_FOR_REN_AND_INVEST - hide
      setShowMaybankAcctDtls(false);
    }
  }//Refinance - hide
  else {
    setShowMaybankAcctDtls(false);
  }
}

const formatBankBanlanceObj = (bbData,id) => {
  const fObj = {
    detailsId: id,
    accountNumber: bbData.AccountNumber,
    bankName:{
        value:bbData.BankName,
        label:bbData.BankNameDescription
    },
    currency:{
        value:bbData .Currency,
        label:bbData.CurrencyDescription
    },
    sixMonthsBalanceAmt: bbData.SixMonthsBalanceAmt
  }

  return fObj;
}

const bindBankBalanceList = (resData) => {
  console.log('@bindBankBalanceList ');
  const bbArray = resData.PropertyDetails.BankBalanceDetails?resData.PropertyDetails.BankBalanceDetails:'';
  let formattedArray = [];
  if(bbArray === '' || bbArray === null) {
      return formattedArray;
  }

  if(!Array.isArray(bbArray)){
    const fBBObj = formatBankBanlanceObj(bbArray,1);
    formattedArray.push(fBBObj);
  }
  else {
    if(bbArray.length > 0){
      for(let i in bbArray) {
          const fBBObj = formatBankBanlanceObj(bbArray[i],i);
          formattedArray.push(fBBObj);
      }
    }
    else {
      formattedArray = [];
    }
  }
  setBankBalanceList(formattedArray);
}

const bindMontlyDebtCommitments = (resData) => {
  console.log('@bindMontlyDebtCommitments ');
  // const mdcArray = resData.PropertyDetails.MonthlyDebtCommitments?resData.PropertyDetails.MonthlyDebtCommitments:'';
  // let formattedArray = [];
  // if(mdcArray === '' || mdcArray === null) {
  //     return formattedArray;
  // }
  // if(!Array.isArray(mdcArray)) {
  //   formattedArray.push(mdcArray);
  // }
  // else {
  //   if(mdcArray.length > 0) {
  //     formattedArray = mdcArray;
  //   }
  // }
  // setMonthlyDebtCommitList(formattedArray);
  let formattedArray = [];
  const mdcArray = resData.PropertyDetails.MonthlyDebtCommitments?resData.PropertyDetails.MonthlyDebtCommitments:'';
  // console.log('mdcArray: ',mdcArray)
  if(mdcArray === '' || mdcArray === null) {
      return formattedArray;
  }
  if(!Array.isArray(mdcArray)) {
    const fObj = formatMonthlyDebtCommitObj(mdcArray);
    formattedArray.push(fObj);
  }
  else {
    if(mdcArray.length > 0) {
      for(let i in mdcArray) {
          const fObj = formatMonthlyDebtCommitObj(mdcArray[i]);
          formattedArray.push(fObj);
      }
    }
    else {
      formattedArray = [];
    }
  }
  // console.log('bindMontlyDebtCommitments: ',formattedArray);
  setMonthlyDebtCommitList(formattedArray);
}

const formatMonthlyDebtCommitObj = (mdcObj) => {
  const fObj = {
    ddlLoanProdType:{
        value:mdcObj.LoanProductType,
        label:mdcObj.LoanProductTypeDescription
    },
    ddlNoOfBank:{
        value:mdcObj.NumberOfBanks,
        label:mdcObj.NumberOfBanksDescription
    },
    amount: mdcObj.Amount,
  }
  return fObj;
}


const getOTPCurrentTime = () => {
  let cTime = helper.getCurrentTime();
  setCurrentTime(cTime);
  setTimeout(getOTPCurrentTime,1000);
}

const showErrMsg = (msg) => {
  setIsError(true);
  setErrMsg(msg);
  setErrMsgTimeout();
}

const setErrMsgTimeout= () => {
  timer = setTimeout(() => {
      setIsError(false);
  }, config.error.msgTimeout);
}

const onOTPSubmitSuccess = () => {
  //OTP Submitted Sucessfully, do Next upon fsd.
  // console.log('onOTPSubmitSuccess Yayy')
  submitWithFields();
}

const getIsNonLendingCompleted = () => {
  if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') {
    return 'N';
  }
  else {
    return 'Y';
  }
}

const getIsPureAIPSubmission = () => {
  if(storage.getIsAIPSubmission() === 'Y') {
    return 'Y';
  }
  else {
    return 'N';
  }
}

const submitWithFields = () => {
  setIsSubmitting(true);

  let params = {
    RefNo:storage.getRefNo(),
    OrderNumber:getAPOrderNo(),
    IDNumber:response.ApplicantsDtlsMyInfo.IDNumber.trim(),
    Status: preKOSubmitted,  // addtional for PreKnockout Status
    isAuthorisedPerson: storage.getIsGreenAP(),
    IsNonLendingCompleted:getIsNonLendingCompleted()
  }

  service.submit(params).then(res => {   
    setIsSubmitting(false);
    if(getIsNonLendingCompleted() === 'N') { //first AP 
      goNext();
      return;
    }
    //subsequent AP
    if(res.data.isSucess) {
      if(res.data.model.refNo === null) {
        goPreKnockoutFailed('M21'); //submit to waa failed
        return;
      }
      //sucess
      goNext();
    }  
    else {
      if(res.data.model.refNo === null) {
        goPreKnockoutFailed('M21'); //submit to waa failed
        return;
      }
      showErrMsg(config.error.SaveApiFailed);
    } 
    }).catch(err => {
      setIsSubmitting(false);
      console.log('err: ',err);
      showErrMsg(config.error.SaveApiFailed);
    })
}

const goNext = () => {
  let UEN = response.companydetails.CompDtls.Company_UEN;
  let IDNum = response.ApplicantsDtlsMyInfo.IDNumber.trim();
  let stateID = storage.getStateId();
  let refNum = storage.getRefNo();
  if(config.EnableNonLending){
    if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') {
      storage.setShowNonLending(true);
    }
    else {
      storage.setShowNonLending(false);
    }
  }
  else {
    storage.setShowNonLending(false);
  }

  history.push(config.route.StatusDetails,{from: config.route.Preview,uen:UEN,idNum:IDNum,sid:stateID,refNo:refNum});
}

const showEditTitle = () => {
  if(response.ApplicantsDtlsMyInfo !== undefined) {
      if(response.ApplicantsDtlsMyInfo.isFirstUser === 'false') {
          return false;
      }
      else {
          return true;
      }
  }
  return false;
}

const validateForm = () => {
 
    let fieldName = 'true';

    //Finance Details
    if(validateFinanceDetails() !== 'true'){
      fieldName = validateFinanceDetails();
    }  
    else if(validateCompanyDetails() !== 'true') {
      fieldName = validateCompanyDetails();
    }
    else if(validateAccountDetails() !== 'true') {
      fieldName = validateAccountDetails();
    }
    
    if(fieldName !== 'true') {
      showErrMsg(fieldName+' is required field. Please click edit button to update the form.');
      return fieldName;
    } 

    return fieldName;
}

const validateFinanceDetails = () => {
    let fieldName = 'true';

    //Finance Details
    if(response.Request_Form.FinancingAmount === undefined || response.Request_Form.FinancingAmount === null || response.Request_Form.FinancingAmount === ''){  
      fieldName = previewData.label.financingAmt;
    }
    else if(response.Request_Form.FinancingTenure === undefined || response.Request_Form.FinancingTenure === null || response.Request_Form.FinancingTenure === '') {
      fieldName = previewData.label.tenure;
    }
    else if(response.Request_Form.IndicativeMonthlyInstallment === undefined || response.Request_Form.IndicativeMonthlyInstallment === null || response.Request_Form.IndicativeMonthlyInstallment === '') {
      fieldName = previewData.label.indicativeMonthylyInstalment;
    }

    return fieldName;
}

const validateCompanyDetails = () => {
  let fieldName = 'true';
  if(response.companydetails.CompDtls.Company_UEN === undefined || response.companydetails.CompDtls.Company_UEN === null || response.companydetails.CompDtls.Company_UEN === '') {
    fieldName = comdetailsdata.label.RegNo;
  }
  else if(response.companydetails.CompDtls.Company_Name === undefined || response.companydetails.CompDtls.Company_Name === null || response.companydetails.CompDtls.Company_Name === '') {
    fieldName = comdetailsdata.label.CompName;
  }
  else if(response.companydetails.CompDtls.Entity_Type_Desc === undefined || response.companydetails.CompDtls.Entity_Type_Desc === null || response.companydetails.CompDtls.Entity_Type_Desc === '') {
    fieldName = comdetailsdata.label.CompType;
  }
  else if(response.companydetails.CompDtls.Registration_Date === undefined || response.companydetails.CompDtls.Registration_Date === null || response.companydetails.CompDtls.Registration_Date === '') {
    fieldName = comdetailsdata.label.CompType;
  }
  else if(response.companydetails.CompDtls.country_of_incorporation_Code === null|| response.companydetails.CompDtls.country_of_incorporation_Code === "" || response.companydetails.CompDtls.country_of_incorporation_Code === undefined) {
    fieldName = comdetailsdata.label.CountryOfInc;
  }
  else if(response.companydetails.CompDtls.Primary_Activity_Desc === null || response.companydetails.CompDtls.Primary_Activity_Desc === "" || response.companydetails.CompDtls.Primary_Activity_Desc === undefined) {
    fieldName = comdetailsdata.label.primaryBiz;
  }
  //27 Nov 22 Ish asked to remove after PIV
  // else if(response.companydetails.CompDtls.Capital_IssuedAmount === null|| response.companydetails.CompDtls.Capital_IssuedAmount === "" || response.companydetails.CompDtls.Capital_IssuedAmount === undefined) {
  //   fieldName = comdetailsdata.label.issuedCapAmt;
  // }
  else if(validateRegBizMailAddr() !== 'true') {
    fieldName = validateRegBizMailAddr();
  }
  else if(response.companydetails.financialHighlights === null) {
    fieldName = 'Financial Highlights';
  }
  else if(response.companydetails.financialHighlights.LatestFinancialYearEndDate === null || response.companydetails.financialHighlights.LatestFinancialYearEndDate === "" || response.companydetails.financialHighlights.LatestFinancialYearEndDate === undefined) {
    fieldName = comdetailsdata.label.latestFinancialYrEndDate;
  }
  else if(response.companydetails.financialHighlights.AnnualRevenue1 === null || response.companydetails.financialHighlights.AnnualRevenue1 === undefined) {
    fieldName = comdetailsdata.label.annualRevenue;
  }
  else if(response.companydetails.financialHighlights.ProfitOrLossBeforeTax1 === null || response.companydetails.financialHighlights.ProfitOrLossBeforeTax1 === undefined) {
    fieldName = comdetailsdata.label.profitLossBeforeTax;
  }
  
  return fieldName;
}

const validateRegBizMailAddr = () => {
  let resObj = response.companydetails.RegBizMailAddr;
  let fieldName = 'true';
  if(resObj.isMailAddressSameAsRegisterAddress === 'N') {
    if(resObj.Address_Format_Type === config.addTypeLocal ||resObj.Address_Format_Type === config.addTypeMultiStorery) {
 
      if(resObj.Postal_Code === undefined || resObj.Postal_Code === null || resObj.Postal_Code === ''){
        fieldName = comdetailsdata.label.PostalCode;
      }
      else if(resObj.Block_Number === undefined || resObj.Block_Number === null || resObj.Block_Number === ''){
        fieldName = comdetailsdata.label.BlkNo;
      }
      else if(resObj.Storey_Number === undefined || resObj.Storey_Number === null || resObj.Storey_Number === ''){
        fieldName = comdetailsdata.label.StoreyNo;
      }
      else if(resObj.Unit_Number === undefined || resObj.Unit_Number === null || resObj.Unit_Number === ''){
        fieldName = comdetailsdata.label.UnitNo;
      }
      else if(resObj.Street_Name === undefined || resObj.Street_Name === null || resObj.Street_Name === ''){
        fieldName = comdetailsdata.label.Street;
      }
    }
    else if(resObj.Address_Format_Type === config.addTypeLockedBag) {
      if(resObj.Post_Office_Name === undefined || resObj.Post_Office_Name === null || resObj.Post_Office_Name === ''){
        fieldName = comdetailsdata.label.PostOffice;
      }
      else if(resObj.Locked_Bag_Number === undefined || resObj.Locked_Bag_Number === null || resObj.Locked_Bag_Number === '') {
        fieldName = comdetailsdata.label.LockedBagNo;
      }
    }
    else if(resObj.Address_Format_Type === config.addTypeGodown) {
  
      if(resObj.Godown_Number === undefined || resObj.Godown_Number === null || resObj.Godown_Number === ''){
        fieldName = comdetailsdata.label.GodownNo;
      }
    
    }
    else if(resObj.Address_Format_Type === config.addTypeMultiStorery) {
       if(resObj.Block_Number === undefined || resObj.Block_Number === null || resObj.Block_Number === ''){
        fieldName = comdetailsdata.label.BlkNo;
       }
       else if(resObj.Storey_Number === undefined || resObj.Storey_Number === null || resObj.Storey_Number === '') {
        fieldName = comdetailsdata.label.StoreyNo;
       }
       else if(resObj.Unit_Number === undefined || resObj.Unit_Number === null || resObj.Unit_Number === '') {
        fieldName = comdetailsdata.label.UnitNo;
       }
       else if(resObj.Street_Name === undefined || resObj.Street_Name === null || resObj.Street_Name === '') {
        fieldName = comdetailsdata.label.Street;
       }
    }
    else if(resObj.Address_Format_Type === config.addTypeLotMukim) {
      if(resObj.Lot_Mukim_Number === undefined || resObj.Lot_Mukim_Number === null || resObj.Lot_Mukim_Number === ''){
        fieldName = comdetailsdata.label.LotMukimNo;
       }
       else if(resObj.Street_Name === undefined || resObj.Street_Name === null || resObj.Street_Name === '') {
        fieldName = comdetailsdata.label.Street;
       }
    }
    else if(resObj.Address_Format_Type === config.addTypePObox) {
      if(resObj.Box_Number === undefined || resObj.Box_Number === null || resObj.Box_Number === ''){
        fieldName = comdetailsdata.label.BoxNo;
       }
       else if(resObj.Post_Office_Name === undefined || resObj.Post_Office_Name === null || resObj.Post_Office_Name === '') {
        fieldName = comdetailsdata.label.PostOffice;
       }
    }
    else if(resObj.Address_Format_Type === config.addTypeWindowDeli) {

      if(resObj.Window_Delivery_Number === undefined || resObj.Window_Delivery_Number === null || resObj.Window_Delivery_Number === ''){
        fieldName = comdetailsdata.label.HouseNo;
       }
       else if(resObj.Post_Office_Name === undefined || resObj.Post_Office_Name === null || resObj.Post_Office_Name === '') {
        fieldName = comdetailsdata.label.PostOffice;
       }
    }
    else if(resObj.Address_Format_Type === config.addTypeForeign) {
      if(resObj.Address_Line1 === undefined || resObj.Address_Line1 === null || resObj.Address_Line1 === ''){
        fieldName = comdetailsdata.label.AddLine1;
       }
       else if(resObj.Address_Line2 === undefined || resObj.Address_Line2 === null || resObj.Address_Line2 === '') {
        fieldName = comdetailsdata.label.AddLine2;
       }
    }
  }

  return fieldName;
}

const validateAccountDetails = () => {
  let fieldName = 'true';
  if(storage.getIsFProdBTL() === 't') {
    let resObj = response.AccountDetails;
    if(resObj.Disbursement_Branch_Desc === undefined || resObj.Disbursement_Branch_Desc === null || resObj.Disbursement_Branch_Desc === ''){
      fieldName = previewData.label.prefBranch;
    }
  }
  
 
  return fieldName;
}
 
const validatePersonDetails = () => {
  if(completedApplicants.length !== 0) {
 
    return validateCompleteAP();
  }
  if(pendingApplicants.length !== 0) {
    
    return validatePendingAP();
  }
}


const validateCompleteAP = () => {
  let fieldName = 'true';
  let isValid = true;
  let resObj = {};

  for(let i in completedApplicants) {
    resObj = completedApplicants[i].myInfo;
    
    if(resObj.TitleCode === undefined || resObj.TitleCode === null || resObj.TitleCode === ''){
      fieldName = personData.titleDDL.lblname;
      isValid = false;
    }
    else if(resObj.MaritalStatusCode === undefined || resObj.MaritalStatusCode === null || resObj.MaritalStatusCode === ''){
      fieldName = personData.marStatusDDL.lblname;
      isValid = false;
    }
    else if(resObj.CountryOfResidenceCode === undefined || resObj.CountryOfResidenceCode === null || resObj.CountryOfResidenceCode === ''){
      fieldName = personData.label.countryOfDom;
      isValid = false;
    }
    else if(resObj.MobileNumber === undefined || resObj.MobileNumber === null || resObj.MobileNumber === ''){
      fieldName = personData.label.mno;
      isValid = false;
    }
    else if(resObj.Email_Address === undefined || resObj.Email_Address === null || resObj.Email_Address === ''){
      fieldName = personData.label.em;
      isValid = false;
    }
  
    if(!isValid) {
      showErrMsg(fieldName+' is required field. Please click edit button to update the form.');
    }
  }

  return isValid;
}

const validatePendingAP = ( ) => {
  let fieldName = 'true';
  let isValid = true;
  let resObj = {};
  for(let i in pendingApplicants) {
    resObj = pendingApplicants[i].myInfo;
    if(resObj.MobileNumber === undefined || resObj.MobileNumber === null || resObj.MobileNumber === ''){
      fieldName = personData.label.mno;
      isValid = false;
    }
    else if(resObj.Email_Address === undefined || resObj.Email_Address === null || resObj.Email_Address === ''){
      fieldName = personData.label.em;
      isValid = false;
    }
    if(!isValid) {
      showErrMsg(fieldName+' is required field. Please click edit button to update the form.');
    }
  }
  
  return isValid;
}

const getPurposeString = () => {
  let result = '',temp = [];
  
  if(response.Request_Form.WCL === 'Y') {
    temp.push(mData.label.chkWCL);
  }
  if(response.Request_Form.Property === 'Y') {
    temp.push(mData.label.chkProperty);
  }
  if(response.Request_Form.Trade === 'Y'){
    temp.push(mData.label.chkTrade);
  }
  if(response.Request_Form.GAS === 'Y') {
    temp.push(mData.label.chkGAS);
  }
  if(response.Request_Form.ESG === 'Y') {
    temp.push(mData.label.chkESG);
  }

  if(temp.length === 1) {
    result = temp[0];
  }
  else {
    result = temp.join(', ');
  }
  
  return result;
}
 
const showFinancingAmt = () => {
  let show = true;
  if((response.Request_Form.FinancingProduct === mData.bizFinanceType.Online) || (response.Request_Form.FinancingProduct === mData.bizFinanceType.Personalised)) {
    show = true;
  }
  else { //AIP
    if(response.Request_Form.IsExistingOTPAvailable && response.Request_Form.IsExistingOTPAvailable === 'N') {
      show = false;
    }
    else {
      show = true;
    }
  }
  return show;
}

if(isLoading) {
  return(
      <Loading />
  )
}

    return(
        <div className="container-fluid"> 
          <br/>
          <SubHeader title={'SME e-Financing Application Summary'} /> 
          <br/>
          <Form onSubmitClick={handleSubmit} 
            initialValues={initFormData}
            key={JSON.stringify(initFormData)}
            render={(formRenderProps)=>(
            <FormElement>
              <FormContainer>
                <fieldset>
           
                  <Field component={CusFormTitle} id={'fst1'} name={previewData.formContainerTitle.T1.name} showEdit={false} />
                    
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblfnType'} leftLabelName={previewData.label.financingType}
                    id={'fnType'} name={response.Request_Form.FinancingType !== null?response.Request_Form.FinancingType:''} />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblFinancingProd'} leftLabelName={previewData.label.financingProduct}
                    id={'FinancingProd'} name={response.Request_Form.FinancingProductDescription !==null? response.Request_Form.FinancingProductDescription:''} />
                </fieldset>
              </FormContainer>  
            
              <FormContainer>
                <fieldset>
                  <Field component={CusFormTitle} id={config.route.FinanceDetails} name={previewData.formContainerTitle.T2.name} showEdit={showEditTitle()} onEdit={handleOnEdit} />

                  {showFinancingAmt()&&
                  <>
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblfnAmt'} leftLabelName={previewData.label.financingAmt}
                    id={'fnAmt'} name={(response.Request_Form.FinancingAmount !==null || response.Request_Form.FinancingAmount !=='0.00')?('SGD '+helper.formatAmount(response.Request_Form.FinancingAmount)):''} />
          
                  {/* {!config.UseFixedInterestRate &&
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblfnItr'} leftLabelName={previewData.label.interestRate}
                    id={'fnItr'} name={(response.Request_Form.IndicativeInterestRate)?(response.Request_Form.IndicativeInterestRate+' %'):''} />
                    } */}

                  </>}

                  {(response.Request_Form.FinancingProduct === mData.bizFinanceType.Online) &&  //BTL
                  <>

                  <Field component={CusFormLabel} 
                    leftLabelId={'lbltenure'} leftLabelName={previewData.label.tenure}
                    id={'tenure'} name={response.Request_Form.FinancingTenure !==null?response.Request_Form.FinancingTenure+' years':''} />
             
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblIndiMonthIns'} leftLabelName={previewData.label.indicativeMonthylyInstalment}
                    id={'IndiMonthIns'} name={response.Request_Form.IndicativeMonthlyInstallment !==null?'SGD '+response.Request_Form.IndicativeMonthlyInstallment:''} />
                  </>
                  }
 
                  {(response.Request_Form.FinancingProduct === mData.bizFinanceType.Personalised) &&  
                  <> 
                    <Field component={CusFormLabel} 
                      leftLabelId={'lblPurpose'} leftLabelName={previewData.label.purpose}
                      id={'purpose'} name={getPurposeString()} />
                  </>
                  }

                  {(response.Request_Form.FinancingProduct === mData.bizFinanceType.AIP) &&  
                  <> 
                    <Field component={CusFormLabel} 
                      leftLabelId={'lblPurpose'} leftLabelName={previewData.label.purpose}
                      id={'purpose'} name={'Property'} />
                  </>
                  }
                  
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblPromoCode'} leftLabelName={previewData.label.promoCode}
                    id={'PromoCode'} name={response.Request_Form.PromoCode !==null?response.Request_Form.PromoCode:'None'} />
                    
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblRefCode'} leftLabelName={previewData.label.referralCode}
                    id={'RefCode'} name={response.Request_Form.ReferralCode !==null?response.Request_Form.ReferralCode:'None'} />
                </fieldset>
              </FormContainer>

              <FormContainer>
                <fieldset>
                  <Field component={CusFormTitle} id={config.route.CompanyDetails} name={previewData.formContainerTitle.T3.name} showEdit={showEditTitle()} onEdit={handleOnEdit}/>
                    
                  <BizDtlsPreview response={response.companydetails.CompDtls} />
                  
                  <FieldWrapper>
                  <Field component={CusFormTitle} id={'fst4'} name={previewData.formContainerTitle.T4.name} showEdit={false} />
                  {/* check addType Foreign. If addType is F, then show add line 1,2 */}
                  <BizRegisterAddress addType={response.companydetails.CompDtls.Address_Type_Code} response={response.companydetails.CompDtls} /> 
                  </FieldWrapper>
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblSameAsRegBizAddr'} leftLabelName={previewData.label.isSameMailAddr} 
                    id={'SameAsRegBizAddr'} name={response.companydetails.RegBizMailAddr.isMailAddressSameAsRegisterAddress == 'Y'? 'Yes':'No'} />
                  {/* check reponse SameasMailing Y, N here */}
                  {response.companydetails.RegBizMailAddr.isMailAddressSameAsRegisterAddress === 'N' &&
                  <FieldWrapper>
                    <Field component={CusFormTitle} id={'fst5'} name={previewData.formContainerTitle.T5.name} showEdit={false} />
                    {/* check addType Foreign. If addType is F, then show add line 1,2 */}
                      <BizMailingAddress addType={response.companydetails.RegBizMailAddr.Address_Format_Type} response={response} /> 
                  </FieldWrapper> 
                  }
                </fieldset>
              </FormContainer>

              <FormContainer>
              
                <Field component={CusFormTitle} id={config.route.CompanyDetails} name={previewData.formContainerTitle.T6.name} showEdit={showEditTitle()} onEdit={handleOnEdit}/>

                {/* <FinancialHighlights minData={financialHighlights.minData} maxData={financialHighlights.maxData} /> */}
                  {response.companydetails.financialHighlights !==null &&
                  <MFinancialPreview response={response.companydetails.financialHighlights}/>
                  }
                  
                <FieldWrapper></FieldWrapper>

                <Field component={CusFormTitle} id={'fst7'} name={previewData.formContainerTitle.T7.name} showEdit={false} />

                <Field component={CusFormLabel} 
                  leftLabelId={'lblIssuedCapAmt'} leftLabelName={comdetailsdata.label.issuedCapAmt}
                  id={'issuedCapAmt'} name={response.companydetails.CompDtls.Capital_IssuedAmount !=='0.00'?response.companydetails.CompDtls.Capital_IssuedAmount:'Not Applicable'}/>

                <Field component={CusFormLabel} 
                  leftLabelId={'lblBizFormerName'} leftLabelName={comdetailsdata.label.bizFormerName}
                  id={'bizFormerName'} name={response.companydetails.CompDtls.Business_Former_Name !== null?response.companydetails.CompDtls.Business_Former_Name:'Not Applicable'}/>
              </FormContainer>
              <FormContainer>
               
                {completedApplicants.map((item, idx) => (
                    <div key={idx}>
                      <Field component={CusFormTitle} id={config.route.NSPersonDetails} name={item.showCPFAndNOA === true? 'Personal Details':'Details of Proprietor/Partner(s)/Director(s)/Shareholder(s)'} showEdit={item.allowEdit} onEdit={handleOnEdit} />
                      <PersonDtlsPreview personDetails={item} isFirstUser={checkIsFirstUser(response.ApplicantsDtlsMyInfo)} cpfHistory={loginAPCPFHistory} yrOfAssessment={loginAPYrAssestment} />
                      {idx+1 !== completedApplicants.length &&
                        <div style={{paddingBottom:'10px'}}> <hr className="greyPanelLine"/> </div>
                       }
                    </div>
                  ))
                }
 
              </FormContainer>
              {pendingApplicants.length !== 0 && 
                <FormContainer>
                  <Field component={CusFormTitle} id={config.route.NSPersonDetails} name={previewData.formContainerTitle.T12.name} showEdit={false} onEdit={handleOnEdit} />
                
                  {pendingApplicants.map((item, idx) => (
                    <div key={idx} >
                      <PersonDtlsPendingPreview personDetails={item}  />
                       {idx+1 !== pendingApplicants.length &&
                        <div style={{paddingBottom:'15px'}}> <hr className="greyPanelLine"/> </div>
                       }
                    </div>
                    
                  ))
                }
                </FormContainer>
              }
              {(storage.getIsFProdBTL() === 't')&&
              <FieldWrapper>
              <FormContainer>
                <Field component={CusFormTitle} id={config.route.AccountDetails} name={previewData.formContainerTitle.T8.name} showEdit={showEditTitle()} onEdit={handleOnEdit} />
                <Field component={CusFormLabel} 
                  leftLabelId={'lblPrefBankBranch'} leftLabelName={previewData.label.prefBranch}
                  id={'PrefBankBranch'} name={response.AccountDetails.Disbursement_Branch_Desc !== null? response.AccountDetails.Disbursement_Branch_Desc:''}/>

                {response.AccountDetails.Disbursement_Branch_Account_No !== null &&
                <Field component={CusFormLabel} 
                  leftLabelId={'lblPrefAccount'} leftLabelName={previewData.label.prefAccount}
                  id={'PrefAccount'} name={response.AccountDetails.Disbursement_Branch_Account_No !== null?response.AccountDetails.Disbursement_Branch_Account_No:''}/>
                }
              </FormContainer>
              </FieldWrapper>
              }
              {(storage.getIsFProdBTL() === 'f' && storage.getIsFPTypeProperty() == 't')&&  //Property Details
              <>
              <FormContainer>
                <FieldWrapper>
                  <Field component={CusFormTitle} id={config.route.PropertyDetails} name={previewData.formContainerTitle.T13.name} showEdit={showEditTitle()} onEdit={handleOnEdit} />
                 
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblTypeOfFinancing'} leftLabelName={pData.label.typeOfFinance}
                    id={'typeOfFinancing'} name={response.PropertyDetails.TypeOfFinanceDescription !== null?response.PropertyDetails.TypeOfFinanceDescription:'Not Applicable'}/>

                  {/* Latest outstanding loan amount */}
                  {response.PropertyDetails.TypeOfFinance === pData.typeOfFinanceRdo.secValue &&
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblLatestOutLoanAmt'} leftLabelName={pData.label.latestOutLoanAmt}
                    id={'latestOutLoanAmt'} name={response.PropertyDetails.LatestOutstandingLoanAmt !== null?('SGD '+helper.formatAmount(response.PropertyDetails.LatestOutstandingLoanAmt)):'Not Applicable'}/>
                  }

                  {response.PropertyDetails.TypeOfFinance === pData.typeOfFinanceRdo.firstValue &&
                  <div>
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblPurposeOfProp'} leftLabelName={pData.label.purpose}
                    id={'purposeOfProp'} name={response.PropertyDetails.PurposeDescription !== null?response.PropertyDetails.PurposeDescription:'Not Applicable'}/>
        
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblPropInMind'} leftLabelName={pData.label.propertyInMind}
                    id={'propInMind'} name={response.PropertyDetails.PropertyInMindDescription !== null?response.PropertyDetails.PropertyInMindDescription:'Not Applicable'}/>
                    {(response.PropertyDetails.PropertyInMind === 'Y')&&
                    <div>
                      <Field component={CusFormLabel} 
                        leftLabelId={'lblPropertyType'} leftLabelName={pData.label.propertyType}
                        id={'propertyType'} name={response.PropertyDetails.PropertyTypeDescription !== null?response.PropertyDetails.PropertyTypeDescription:'Not Applicable'}/>

                      <Field component={CusFormLabel} 
                        leftLabelId={'lblPurchasePrice'} leftLabelName={pData.label.purchasePrice}
                        id={'purchasePrice'} name={response.PropertyDetails.PurchasePrice !== null?('SGD '+helper.formatAmount(response.PropertyDetails.PurchasePrice)):'Not Applicable'}/>
                    </div>
                  }
                  </div>
                  }
                  {(isPureAIP && showMaybankAcctDtls && response.PropertyDetails.PropertyInMind === 'Y') &&
                  <LeaseholdPreview response={response} />
                  }
 
                </FieldWrapper>
                {response.PropertyDetails.AddressType !== null &&
                <FieldWrapper>
                  <Field component={CusFormTitle} id={config.route.PropertyDetails} name={previewData.label.propertyAddress} showEdit={false} onEdit={handleOnEdit} />
                  <PropertyAddress addType={response.PropertyDetails.AddressType} response={response} />
                </FieldWrapper>
                }
              </FormContainer>

              {isPureAIP && showMaybankAcctDtls &&
              <FormContainer>
                <FieldWrapper>
                  <Field component={CusFormTitle} id={config.route.PropertyDetails} name={pData.formTitle.ft3} showEdit={showEditTitle()} onEdit={handleOnEdit} />
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblHasMaybankAcct'} leftLabelName={pData.label.hasMaybankAcct}
                    id={'hasMaybankAcct'} name={response.PropertyDetails.IsSixMonthsBankBalWithMaybank !== null?response.PropertyDetails.IsSixMonthsBankBalWithMaybankDescription:'Not Applicable'}/>

                  <Field component={CusFormTitle} id={config.route.PropertyDetails} name={previewData.formContainerTitle.T14.name} showEdit={false} onEdit={handleOnEdit} />
                  
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblHasOthbankAcct'} leftLabelName={pData.label.hasOthActiveBankAcct}
                    id={'hasOthbankAcct'} name={response.PropertyDetails.isActiveBizAcctWithOtherBanks !== null?response.PropertyDetails.isActiveBizAcctWithOtherBanksDesc:'Not Applicable'}/>
                  
                  <BankBalanceHistory data={bankBalanceList} isFromPreview={true} />

                  <br/>
                  <Field component={CusFormTitle} id={config.route.PropertyDetails} name={previewData.formContainerTitle.T15.name} showEdit={false} onEdit={handleOnEdit} />
                  
                  {/* {monthlyDebtCommitList.length > 0?
                  <>
                  {monthlyDebtCommitList.map((item, idx) => (
                  <Field key={idx}
                    component={CusFormLabel} 
                    leftLabelId={'lblDebt'} leftLabelName={item.LoanProductTypeDescription}
                    id={'monthlydebt'} name={item.NumberOfBanksDescription+' | S$'+helper.formatAmount(item.Amount)}/>
                  ))}
                  </>
                  :
                  <div className='inputPair txt-center'>
                    No Record
                  </div>
                  } */}
                  <CommitmentHistory data={monthlyDebtCommitList} isFromPreview={true} />
                  
                  <br/>
                 
                  <Field component={CusFormTitle} id={config.route.PropertyDetails} name={previewData.formContainerTitle.T16.name} showEdit={false} onEdit={handleOnEdit} />
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblLatestAnnualIntrestExpense'} leftLabelName={pData.label.annInterestExp}
                    id={'LatestAnnualIntrestExpense'} name={response.PropertyDetails.LatestAnnualIntrestExpense !== null?response.PropertyDetails.LatestAnnualIntrestExpenseCurrency+' '+helper.formatAmount(response.PropertyDetails.LatestAnnualIntrestExpense):'Not Applicable'}/>
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblLatestAnnualDepreciationOrAmortisationAmt'} leftLabelName={pData.label.annDeprecationAmt}
                    id={'LatestAnnualDepreciationOrAmortisationAmt'} name={response.PropertyDetails.LatestAnnualDepreciationOrAmortisationAmt !== null?response.PropertyDetails.LatestAnnualDepreciationOrAmortisationAmtCurrency+' '+helper.formatAmount(response.PropertyDetails.LatestAnnualDepreciationOrAmortisationAmt):'Not Applicable'}/>
                </FieldWrapper>
              </FormContainer>
              }
              </>
              }
              <FormContainer>
                <fieldset>
                <FieldWrapper>
                  <Field name={'PreviewClare'} label={previewData.label.terms} id={'PreviewClare'}
                    component={TermsFormCheckboxNoErrMsgDisplay} 
                    value={true} 
                    disabled={showOTPBar}
                    validator={previewValidator} />
                </FieldWrapper>
                </fieldset>
              </FormContainer>
        
              {!showOTPBar?
              <FormContainer>
                <div style={{paddingTop:'20px',paddingBottom:'20px'}}>
                  <div className="row around-xs inputPair elementVisible">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <button type={'button'} className="k-button btn-back" onClick={handleBack}>{config.btnName.Back}</button>
                      <button type={'submit'} className="k-button btn-success btn-float-right" disabled={!formRenderProps.valid}>{config.btnName.Submit}</button>
                    </div>
                  </div>                            
                </div>
              
              </FormContainer>:
              <FieldWrapper>
                  <br/><br/><br/><br/><br/>
                  <OTPbar id={'1OtP'} userMobileNo={getAPMobileNo() !== null? getAPMobileNo():showErrMsg('Invalid Mobile Number.')} currentTime={currentTime} otpTimer={timer} history={history} handleOTPSubmitSuccess={() =>{onOTPSubmitSuccess()}} />
              </FieldWrapper>
              }
              <br/>
              <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer}  /> 
            </FormElement>
           )} />
          {isSubmitting &&<Loading />}
        </div>
    )
}

export default Preview;